import { call, put, takeEvery } from "redux-saga/effects";
import { taxActions } from "./tax.slice";
import { api } from "Shared/axios";

function* initFetch() {
	const data = yield call(fetchData);
	if (data == undefined) {
		yield put(taxActions.initError());
	} else {
		yield put(taxActions.initResponse(data));
	}
}

function* updateFetch() {
	const data = yield call(fetchData);
	if (data == undefined) {
		yield put(taxActions.updateError());
	} else {
		yield put(taxActions.updateResponse(data));
	}
}

function* fetchData() {
	try {
		const { data: amount } = yield call(api.get, "/payment/request-amount-in-year");
		const { data: settings } = yield call(api.get, "/payment/request-setting");
		return { ...amount, ...settings };
	} catch (error) {
		return undefined;
	}
}

export function* watchTax() {
	yield takeEvery(taxActions.initFetch, initFetch);
	yield takeEvery(taxActions.updateFetch, updateFetch);
}
